<div class="main-content">
  <div class="work-at-luminous-wrap" *ngIf="tabName=='customer-first'">

    <div class="banner">
      <picture>
        <source media="(max-width:768px)" srcset="{{environment?.blobUrl}}/assets/images/core-value/Customer-First-mobile.webp" />
        <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/core-value/Customer-First.webp'" alt="Customer First | Luminous">
      </picture>
    </div>
    <div class="container">

      <div class="row">
        <div class="col-md-6">
          <h1>Customer First</h1>
          <p class="mb-5">Above and Beyond for Our Customers</p>
        </div>
        <div class="col-md-6">
          <p>
            We surprise and delight customers as we would be nowhere without them. So, not only do we put ourselves in
            their shoes, but we also anticipate their needs and go the extra mile. We champion our sales people
            because they are the face of our company. Whatever our role, we have an impact on the customer’s
            experience.</p>
        </div>
      </div>

    </div>
    <div class="py-5 thumb-section">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <span><img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/green-thumb.webp'" alt="Green Thumbs Up Icon | Luminous"></span>
            <ul>
              <li>Prioritizing external customer over internal matters always.</li>
              <li>
                Understanding the needs and experiences of our customers.
              </li>
              <li>Driving improvement in the digital customer experience.</li>
            </ul>
          </div>
          <div class="col-md-6">
            <span><img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/red-thumb.webp'" alt="Red Thumbs Down Icon | Luminous"></span>
            <ul>
              <li>Assuming customer is only the salesperson’s responsibility.</li>
              <li>
                Investing too much time and energy on internal processes.
              </li>
              <li>Focusing on technical or product solutions rather than customers’ business need.</li>
            </ul>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="work-at-luminous-wrap" *ngIf="tabName=='dare-to-disrupt'">
    <!--h1 class="heading1 ">Careers</!--h1-->
    <div class="banner">
      <picture>
        <source media="(max-width:768px)" srcset="{{environment?.blobUrl}}/assets/images/core-value/Dare-to-Disrupt-mobile.webp" />
        <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/core-value/Dare-to-Disrupt.webp'" alt="Dare to Disrupt | Luminous">
      </picture>
    </div>
    <div class="container">

      <div class="row">
        <div class="col-md-6">
          <h1>Dare to Disrupt</h1>
          <p class="mb-5">Constantly in Beta</p>
        </div>
        <div class="col-md-6">
          <p>
            Innovation is our middle name. Good is never good enough, and that’s why we are constantly experimenting,
            taking risks and disrupting the status quo. We think fast and we act even faster. Setbacks don’t hurt us.
            They motivate us. That’s why we are not afraid to make our bets bigger, and our decisions bolder to power
            the digital economy through energy management and automation.</p>
        </div>
      </div>

    </div>
    <div class="py-5 thumb-section">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <span><img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/green-thumb.webp'" alt="Green Thumbs Up Icon | Luminous"></span>
            <ul>
              <li>Taking risks and prioritizing speed over perfection.</li>
              <li>
                Open to new ideas and experimenting.
              </li>
              <li>Acting boldly and challenging the status quo.</li>
            </ul>
          </div>
          <div class="col-md-6">
            <span><img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/red-thumb.webp'" alt="Red Thumbs Down Icon | Luminous"></span>
            <ul>
              <li>Reluctant to question conventional thinking.</li>
              <li>
                More concerned with avoiding risks than seeking successes.
              </li>
              <li>Seeing no need to consider or try different ways of thinking or working.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="work-at-luminous-wrap" *ngIf="tabName=='embrace-different'">
    <!--h1 class="heading1 ">Careers</!--h1-->
    <div class="banner">
      <picture>
        <source media="(max-width:768px)" srcset="{{environment?.blobUrl}}/assets/images/core-value/Embrance-Different-mobile.webp" />
        <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/core-value/Embrance-Different.webp'" alt="Embrace Different | Luminous">
      </picture>
    </div>
    <div class="container">

      <div class="row">
        <div class="col-md-6">
          <h1>Embrace different</h1>
          <p class="mb-5">Different Is Beautiful</p>
        </div>
        <div class="col-md-6">
          <p>
            We are 100% committed to inclusion. ‘Exclusion’ is not even in our vocabulary. We believe in equal
            opportunities for everyone, everywhere. This means welcoming people from all walks of life, ages and
            cultures, embracing different perspectives and calling out bias when we see it. So that every person feels
            uniquely valued and safe to be at their best. To us a stranger is simply a friend we haven’t met yet.</p>
        </div>
      </div>

    </div>
    <div class="py-5 thumb-section">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <span><img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/green-thumb.webp'" alt="Green Thumbs Up Icon | Luminous"></span>
            <ul>
              <li>Connecting with and learning from those with different backgrounds.</li>
              <li>
                Contributing to an inclusive & safe work environment.
              </li>
              <li>Being aware of own biases and seeks constantly to improve.</li>
            </ul>
          </div>
          <div class="col-md-6">
            <span><img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/red-thumb.webp'" alt="Red Thumbs Down Icon | Luminous"></span>
            <ul>
              <li>Devaluing or passively supporting the building of an inclusive environment.</li>
              <li>
                Showing low awareness of own potential biases or their possible impact on decision making.
              </li>
              <li>Showing little interest in diverse others or their perspectives/ideas.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="work-at-luminous-wrap" *ngIf="tabName=='learn-everyday'">
    <!--h1 class="heading1 ">Careers</!--h1-->
    <div class="banner">
      <picture>
        <source media="(max-width:768px)" srcset="{{environment?.blobUrl}}/assets/images/core-value/Learn-Everyday-mobile.webp" />
        <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/core-value/Learn-Everyday.webp'" alt="Learn Everyday | Luminous">
      </picture>
    </div>
    <div class="container">

      <div class="row">
        <div class="col-md-6">
          <h1>Learn Everyday</h1>
          <p class="mb-5">What did you learn today</p>
        </div>
        <div class="col-md-6">
          <p>
            To stop learning is to stop growing. We are genuinely curious, never done with learning. To us, there is no
            such thing as knowing it all or having all the answers. We believe in lifelong learning. Every minute of
            every day brings a new chance to listen, open up our minds, and widen our horizons. We are never too
            experienced to learn.</p>
        </div>
      </div>

    </div>
    <div class="py-5 thumb-section">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <span><img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/green-thumb.webp'" alt="Green Thumbs Up Icon | Luminous"></span>
            <ul>
              <li>Always curious to learning new things and acquire new skills.</li>
              <li>
                Appling new knowledge quickly and practically to daily work.
              </li>
              <li>Connecting with others to exchange, collaborate, teach and learn.</li>
            </ul>
          </div>
          <div class="col-md-6">
            <span><img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/red-thumb.webp'" alt="Red Thumbs Down Icon | Luminous"></span>
            <ul>
              <li>Doesn’t proactively find new ways and rituals to learn (expects the company to initiate).</li>
              <li>
                Doesn’t share knowledge or learn with/teach others.
              </li>
              <li>Struggling to translate learning into significant work impact.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="work-at-luminous-wrap" *ngIf="tabName=='act-like-owners'">
    <!--h1 class="heading1 ">Careers</!--h1-->
    <div class="banner">
      <picture>
        <source media="(max-width:768px)" srcset="{{environment?.blobUrl}}/assets/images/core-value/Act-Like-Owners-mobile.webp" />
        <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/core-value/Act-Like-Owners.webp'" alt="Act Like Owners | Luminous">
      </picture>
    </div>
    <div class="container">

      <div class="row">
        <div class="col-md-6">
          <h1>Act Like Owners</h1>
          <p class="mb-5">All in. Together.</p>
        </div>
        <div class="col-md-6">
          <p>
            Entrepreneurs at heart, we take responsibility and ownership of everything we do. This is not somebody
            else’s company. It’s ours! We are individually empowered and collectively driven to collaborate and beat the
            competition together in the end, we do what is right for Luminous first – always with integrity and honesty.
          </p>
        </div>
      </div>

    </div>
    <div class="py-5 thumb-section">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <span><img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/green-thumb.webp'" alt="Green Thumbs Up Icon | Luminous"></span>
            <ul>
              <li>Demonstrating strong integrity and sense of accountability; goes the extra mile.</li>
              <li>
                Considering what’s best for Luminous overall and acts accordingly.
              </li>
              <li>Collaborating with others to take a ‘One Luminous’ approach.</li>
            </ul>
          </div>
          <div class="col-md-6">
            <span><img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/red-thumb.webp'" alt="Red Thumbs Down Icon | Luminous"></span>
            <ul>
              <li>Reluctant to take responsibility –“it’s only a job”.</li>
              <li>
                Too focused on the limits of their role or personal agenda.
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
